'use client';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useShareButtonTracking } from '../Tracking/hooks/useShareButtonTracking';
import { messages } from './messages';

export type ShareButtonProps = {
  title: string;
  text: string;
};

/**
 * Displays a 'share' button on browsers that support native web-share-api
 * */
export const ShareButton = ({ title, text }: ShareButtonProps) => {
  const { trackButtonClick, trackViewButton } = useShareButtonTracking();
  const { formatMessage } = useIntl();

  useEffect(
    () => {
      trackViewButton();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const onClick = async () => {
    trackButtonClick();
    await window.navigator.share({ title, text, url: window.location.href ?? undefined });
  };
  return (
    <Button onClick={onClick} className="w-full">
      {formatMessage(messages.shareButtonText)}
      <span role="img" className="icon-emp-android size-2" />
    </Button>
  );
};
